import { CLEAR_ACTIVE_DAY_ID, CLEAR_USER_ACTIVE_DAY, SET_ACTIVE_DAY_ID, SET_INCREMENT_CIRCUIT_IN_PROGRESS, SET_INCREMENT_CIRCUIT_SUCCESS, SET_USER_ACTIVE_DAY } from "../actions/types";

const initialState = {
  activeDayId: null,
  activeDay: null,
  isCircuitIncreamentInProgress: false,
};

const userActiveDayReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACTIVE_DAY_ID:
      return {
        ...state,
        activeDayId: action.payload,
      };
    
    case CLEAR_ACTIVE_DAY_ID:
      return {
        ...state,
        activeDayId: null,
      };

    case SET_USER_ACTIVE_DAY:
      return {
        ...state,
        activeDay: action.payload,
      };

    case CLEAR_USER_ACTIVE_DAY:
      return {
        ...state,
        activeDay: null,
      };
  
    case SET_INCREMENT_CIRCUIT_IN_PROGRESS:
      return {
        ...state,
        isCircuitIncreamentInProgress: true,
      };

    case SET_INCREMENT_CIRCUIT_SUCCESS:
      return {
        ...state,
        isCircuitIncreamentInProgress: false,
        activeDay: {
          ...state.activeDay,
          circuit: state.activeDay.circuit + 1,
        },
      };

    default:
      return state;
  }
};

export default userActiveDayReducer;
